var map = {
	"./ArtworkTips.vue": "i2pp",
	"./Benefits.vue": "tAcp",
	"./BrandlyApp.vue": "7xHn",
	"./Demo.vue": "/v6Z",
	"./FeatureItem.vue": "u6P3",
	"./FeatureSection.vue": "HMF7",
	"./GetDemoButton.vue": "IO6r",
	"./GetEmail.vue": "iYzm",
	"./GetPortalButton.vue": "EIcW",
	"./GetQuote.vue": "ap/+",
	"./GetStartedButton.vue": "TPTq",
	"./HowItWorksButton.vue": "RKT0",
	"./HubspotForm.vue": "pb8y",
	"./LandingPageHero.vue": "A9Ar",
	"./LandingPagePortal.vue": "eq6f",
	"./LandingPageSaveTime.vue": "tavi",
	"./NoStrings.vue": "+Twt",
	"./SecondaryHeader.vue": "HgU1",
	"./SectionHeader.vue": "i0Um",
	"./SummaryBlock.vue": "IdgM",
	"./SummaryBlockDark.vue": "0qMr",
	"./Testimonial.vue": "Edwh"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "W/tP";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/homepage/shared \.vue$
// module id = W/tP
// module chunks = 1